import React, { useState } from 'react';
import PropTypes from 'prop-types';

import axios from '@utils/axios';
import { Form, TextField, PageActions, Button } from '@shopify/polaris';

import Webhooks from '@container/shop/Webhooks';

const propTypes = {
  active: PropTypes.bool.isRequired,
  submitURL: PropTypes.string.isRequired,

  webhooks: PropTypes.array,
  webhooksSubmitURL: PropTypes.string.isRequired,
  account: PropTypes.string,
}

const defaultProps = {
  tokenPresent: false
}

const BrightPearlLogin = (props) => {
  const [account, setAccount] = useState("");
  const { active } = props;

  const handleSubmit = async () => {
    let { submitURL, setLoading } = props;
    setLoading(true)

    try {
      let response = await axios.post(submitURL, {
        account: account
      })
      if(response.data.success){
        if (response.data.redirectURL){
          // redirect if required.
          window.location = response.data.redirectURL;
          return true
        } else {
          alert(response.data.message);
        }
        
      } // End success data
      else{
        console.log(response.data);
        alert(response.data.message);
      }
    } catch (error) {
      alert(error);
    } // END try/catch
    setLoading(false)
}

  return(
    <div>
      <div className="mb10">
        <img src={ imagePaths.brightPearlLogo } height="64" style={{ backgroundColor: "#000" }} />
      </div>
      { active  &&
        <h5>
          Conexión con Brightpearl activa con la cuenta { props.account }
        </h5>
      }
      <Form onSubmit={ handleSubmit } >
        <TextField
          id="account"
          label= { I18n.t("activerecord.attributes.general.account") }
          placeholder="unimart"
          onChange={ (value, id) => setAccount(value) }
          value={ account } />
      </Form>
      { active && 
        <Webhooks
          webhooks={props.webhooks}
          submitURL={ props.webhooksSubmitURL }
          topicAttributeName="subscribeTo"
          endpointAttributeName="uriTemplate"
        />
      }
      <PageActions 
        primaryAction={{
          onAction: handleSubmit,
          loading: props.loading,
          content: I18n.t("actions.save")
        }}
      />
    </div>
  )
}

BrightPearlLogin.propTypes = propTypes;
BrightPearlLogin.defaultProps = defaultProps;

export default BrightPearlLogin;